export const DROPBOX_OAUTH_CALLBACK_SOURCE = 'quipex-dropbox-oauth';
export const DROPBOX_OAUTH_CALLBACK_STORAGE_KEY =
    'quipex.dropbox.oauth.callback';

export interface DropboxOAuthCallbackMessage {
    source: typeof DROPBOX_OAUTH_CALLBACK_SOURCE;
    code: string | null;
    state: string | null;
    error: string | null;
    errorDescription: string | null;
}

export function createDropboxOAuthCallbackMessage(
    params: URLSearchParams
): DropboxOAuthCallbackMessage {
    return {
        source: DROPBOX_OAUTH_CALLBACK_SOURCE,
        code: params.get('code'),
        state: params.get('state'),
        error: params.get('error'),
        errorDescription: params.get('error_description'),
    };
}

const DROPBOX_CALLBACK_PATH = '/auth/dropbox/callback';

export function handleDropboxOAuthCallback(): boolean {
    if (window.location.pathname !== DROPBOX_CALLBACK_PATH) return false;

    const message = createDropboxOAuthCallbackMessage(
        new URLSearchParams(window.location.search)
    );

    try {
        window.opener?.postMessage(message, window.location.origin);
    } catch {
        // Some browsers block opener access for OAuth popups. The opener also
        // polls localStorage, so this path can still complete.
    }

    try {
        window.localStorage.setItem(
            DROPBOX_OAUTH_CALLBACK_STORAGE_KEY,
            JSON.stringify(message)
        );
    } catch {
        // Storage can be unavailable in private browsing or locked-down
        // contexts. postMessage above is the primary delivery path.
    }

    window.close();
    document.body.textContent =
        'Dropbox connection complete. You can close this window.';

    return true;
}
